import { render, staticRenderFns } from "./RecruiterQaAttachment.vue?vue&type=template&id=24b36940&scoped=true"
import script from "./RecruiterQaAttachment.vue?vue&type=script&lang=js"
export * from "./RecruiterQaAttachment.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaAttachment.vue?vue&type=style&index=0&id=24b36940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b36940",
  null
  
)

export default component.exports